import { useCallback } from "react";

function useSettingsReturnState({ currentUserId, locationState, navigate }) {
	const getSettingsReturnState = useCallback(() => {
		const backgroundLocation = locationState?.backgroundLocation;
		return {
			returnTo: `/user/${currentUserId}/settings`,
			returnToState: backgroundLocation ? { backgroundLocation } : undefined,
			fromSettings: true,
		};
	}, [currentUserId, locationState]);

	const goToEditProfile = useCallback(() => {
		navigate("/edit-profile", {
			state: getSettingsReturnState(),
		});
	}, [getSettingsReturnState, navigate]);

	const goToEditInterests = useCallback(() => {
		navigate("/edit-interests", {
			state: getSettingsReturnState(),
		});
	}, [getSettingsReturnState, navigate]);

	const goToLocationSettings = useCallback(() => {
		goToEditInterests();
	}, [goToEditInterests]);

	return {
		getSettingsReturnState,
		goToEditProfile,
		goToEditInterests,
		goToLocationSettings,
	};
}

export default useSettingsReturnState;
